export var valueSeparator = '---';
export var attributeSeparator = '___';
export var parseAnalyticsFromQueryParams = function parseAnalyticsFromQueryParams(additionalAnalytics) {
  var formattedEvents = {};
  if (typeof additionalAnalytics !== 'string') {
    return formattedEvents;
  }
  var events = additionalAnalytics === null || additionalAnalytics === void 0 ? void 0 : additionalAnalytics.split('____');
  events.forEach(function (event) {
    var formattedEvent = event === null || event === void 0 ? void 0 : event.split('---');
    var hasProperlyFormattedEvent = formattedEvent.length === 2;
    if (hasProperlyFormattedEvent) {
      formattedEvents[formattedEvent[0]] = formattedEvent[1];
    }
  });
  return formattedEvents;
};